import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignlistComponent } from './campaignlist/campaignlist.component';
import { ModifycampaignComponent } from './modifycampaign/modifycampaign.component';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import {CarouselModule} from 'ngx-owl-carousel-o';

@NgModule({
  declarations: [CampaignlistComponent, ModifycampaignComponent],
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAlertModule,CarouselModule
  ]
})
export class CampaignlistModule { }
